<template>
  <div class="resetPassword">
    <div class="login-content">
      <div class="login-box">
        <div class="reset-pass-header">找回密码</div>
        <div class="reset-pass-step-box">
          <div class="step-item" :class="[step > 0 ? 'active' : '']">
            <div class="step-item-num">1</div>
            <div class="step-item-name">填写信息</div>
          </div>
          <div class="step-division" :class="[step > 1 ? 'active' : '']">
            <div class="step-division__"></div>
            <div class="step-division__"></div>
            <div class="step-division__"></div>
          </div>
          <div class="step-item" :class="[step > 1 ? 'active' : '']">
            <div class="step-item-num">2</div>
            <div class="step-item-name">设置密码</div>
          </div>
          <div class="step-division" :class="[step > 2 ? 'active' : '']">
            <div class="step-division__"></div>
            <div class="step-division__"></div>
            <div class="step-division__"></div>
          </div>
          <div class="step-item" :class="[step > 2 ? 'active' : '']">
            <div class="step-item-num">3</div>
            <div class="step-item-name">完成</div>
          </div>
        </div>
        <el-tabs 
          v-model="activeName" 
          @tab-click="handleClick" 
          v-if="baseDefCount == 2"
          class="elTabsCss"
        >
          <el-tab-pane label="短信找回密码" name="phone" :disabled="step > 1"></el-tab-pane>
          <el-tab-pane label="邮箱找回密码" name="email" :disabled="step > 1"></el-tab-pane>
        </el-tabs>
        <div class="reset-pass-form">
          <!-- 手机短信验证 -- start -->
          <el-form
            ref="resetPass"
            :rules="formRules"
            :model="resetPass"
            :validate-on-rule-change="false"
            v-if="step === 1"
          >
            <el-form-item label="证件号" prop="cardNo">
              <el-input
                type="text"
                v-model="resetPass.cardNo"
                placeholder="请输入证件号"
                @blur="checkAll('resetPass')"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" :error="phoneError" v-if="activeName == 'phone'">
              <el-input
                type="text"
                v-model.trim="resetPass.phone"
                placeholder="请输入手机号"
                @blur="checkAll('resetPass')"
              ></el-input>
            </el-form-item>
            <el-form-item label="短信验证码" prop="vCode" :error="vCodeError" v-if="activeName == 'phone'">
              <el-input
                type="text"
                v-model="resetPass.vCode"
                placeholder="请输入短信验证码"
                @focus="clearError"
              ></el-input>
              <!-- 获取验证码按钮 -->
              <div
                :class="[isgetCode ? 'isgetCode' : 'getCode']"
                @click="[isgetCode ? getVerCode(isgetCode) : '']"
              >
                {{ countDownText }}
              </div>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" :error="emailError" v-if="activeName == 'email'">
              <el-input
                type="text"
                v-model.trim="resetPass.email"
                placeholder="请输入邮箱"
                @blur="checkAll('resetPass')"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱验证码" prop="eCode" :error="eCodeError" v-if="activeName == 'email'">
              <el-input
                type="text"
                v-model="resetPass.eCode"
                placeholder="请输入邮箱验证码"
                @focus="clearError"
              ></el-input>
              <!-- 获取验证码按钮 -->
              <div
                :class="[isgetCode4Email ? 'isgetCode' : 'getCode']"
                @click="[isgetCode4Email ? getVerCode4Email(isgetCode4Email) : '']"
              >
                {{ countDownText4Email }}
              </div>
            </el-form-item>
            <el-form-item>
              <div class="next active" @click="next('resetPass')">下一步</div>
            </el-form-item>
          </el-form>

          <el-form
            ref="resetPass"
            :rules="rule2"
            :model="resetPass"
            v-if="step === 2"
          >
            <el-form-item label="设置新密码" prop="password" :key="1">
              <el-input
                type="text"
                v-model="resetPass.password"
                placeholder="请输入新密码"
                show-password
              ></el-input>
              <ots-password-tooltip></ots-password-tooltip>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword" :key="2">
              <el-input
                type="text"
                v-model="resetPass.confirmPassword"
                placeholder="请再次输入新密码"
                show-password
              ></el-input>
            </el-form-item>
            <!-- <el-form-item> -->
            <div class="next active" @click="rightEditPsd('resetPass')">
              确定
            </div>
            <!-- </el-form-item> -->
          </el-form>
          <div class="reset-finsh" v-if="step === 3">
            <div class="reset-success-icon">
              <img
                src="../../../assets/stuImg/reset-pass-success-icon.png"
                alt=""
              />
            </div>
            <div class="reset-success-text">密码修改成功</div>
            <div class="auto-go-login">
              {{ pushTime }}s后自动跳转登录页面，或<span @click="handleLogin"
                >直接跳转</span
              >
            </div>
          </div>
        </div>
        <!-- 已有账号,返回登录样式 -->
        <div class="back-login" v-if="step == 3 ? false : true">
          <span>已有账号，</span>
          <a href="javascript:void(0);" @click="handleLogin">返回登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPwd, passWordStrength, checkCardId, checkPhone } from "@/common/verify.js";
export default {
  name: "resetPassword",
  data() {
    return {
      // "获取验证码" 按钮开关
      isgetCode: false,
      // 按钮文字
      countDownText: "获取验证码",
      // 距离再次获取验证码的剩余秒数
      count: 120,
      // 获取验证码定时器
      timer: null,
      // 手机号其它报错信息
      phoneError: "",
      // 短信验证码报错信息
      vCodeError: "",
      // 获取到的验证码
      getVcode: "",

      // "获取验证码" 按钮开关
      isgetCode4Email: false,
      // 按钮文字
      countDownText4Email: "获取验证码",
      // 距离再次获取验证码的剩余秒数
      count4Email: 120,
      // 获取验证码定时器
      timer4Email: null,
      // 手机号其它报错信息
      emailError: "",
      // 短信验证码报错信息
      eCodeError: "",
      // 获取到的验证码
      getEcode: "",

      step: 1,
      pushTime: 5,
      resetPass: {
        tenant: this.$route.query.tenant ? this.$route.query.tenant : "",
        userId: "",
        cardNo: "",
        phone: "",
        vCode: "",
        email: "",
        eCode: "",
        password: "",
        confirmPassword: "",
      },
      rule1: {
        cardNo: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          { validator: checkCardId, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: checkPhone, trigger: "change" },
        ],
        vCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      rule2: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      baseDefCount: 0, //如果是2，则显示上面的页签，否则不显示
      requiredList: [],
      activeName: ''
    };
  },
  created() {
    let myEndTime = localStorage.getItem("resetPassword_myEndTime");
    myEndTime && this.codeCountDown(myEndTime);
    let myEndTime4Email = localStorage.getItem("resetPassword_myEndTime4Email");
    myEndTime4Email && this.codeCountDown4Email(myEndTime4Email);
    this.getBaseDefList();
  },
  computed: {
    formRules() {
      const nowPhone = this.activeName === 'phone';
      const nowEmail = this.activeName === 'email';
      let rules = {
        cardNo: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          { validator: checkCardId, trigger: "blur" },
        ]
      }
      if(nowPhone){
        rules.phone = [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: checkPhone, trigger: "change" },
        ],
        rules.vCode = [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ]
      }
      if(nowEmail){
        rules.email = [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { message: "邮箱格式错误", trigger: "blur", type: "email" },
        ],
        rules.eCode = [
          { required: true, message: "请输入邮箱证码", trigger: "blur"},
        ]
      }
      return rules;
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name == 'phone' ? 'phone' : 'email';
      this.$nextTick(() => {
        this.$refs.resetPass.clearValidate();
      })
    },
    /*************************
     * @this 获取手机和邮箱的相关设置
     *************************/
    getBaseDefList() {
      let params = this.$route.query.tenant;
      this.$api.system.getSystemNameFN({ tenant: params }).then((res) => {
        if(res.code == 1){
          this.baseDefCount = res.data.baseDefList
            .filter(item => item.fieldName == 'phone' || item.fieldName == 'email')
            .filter(item => item.required == 1)
            .length;
          this.requiredList = res.data.baseDefList.filter(item => item.required == 1).map(item => item.fieldName);
          this.activeName = this.requiredList.includes('phone') ? 'phone' : 'email';
        }else{
          this.handleLogin();
        }
      });
    },
    /* ***** 证件号,手机号全部满足，开启验证码按钮 (valid:errorMessage) ***** */
    checkAll(formName) {
      if(this.activeName == 'phone'){
        // 1.验证证件号
        this.$refs[formName].validateField(["cardNo"], (valid) => {
          if (!valid) {
            // 2.验证手机号
            this.$refs[formName].validateField(["phone"], (valid) => {
              // 3. 验证通过,重置错误信息
              if (!valid) {
                this.phoneError = "";
              }
              // 4. 验证通过,开启"获取验证码"按钮
              // 5. 判断当前是否在计时
              if (this.count < 120) {
                return false;
              } else {
                this.isgetCode = valid ? false : true;
              }
            });
          } else {
            // 5.验证不通过,关闭"获取验证码"按钮
            this.isgetCode = false;
          }
        });
      }else{
        // 1.验证证件号
        this.$refs[formName].validateField(["cardNo"], (valid) => {
          if (!valid) {
            // 2.验证手机号
            this.$refs[formName].validateField(["email"], (valid) => {
              // 3. 验证通过,重置错误信息
              if (!valid) {
                this.emailError = "";
              }
              // 4. 验证通过,开启"获取验证码"按钮
              // 5. 判断当前是否在计时
              if (this.count4Email < 120) {
                return false;
              } else {
                this.isgetCode4Email = valid ? false : true;
              }
            });
          } else {
            // 5.验证不通过,关闭"获取验证码"按钮
            this.isgetCode4Email = false;
          }
        });
      }
    },

    /* ***** 验证码按钮能否发送短信,失败验证返回错误 ***** */
    getVerCode(state) {
      // 1.判断验证码功能是否开启，调用接口
      if (state) {
        let { cardNo, phone, tenant } = this.resetPass;
        this.$api.login
          .checkUserCardPhone({ cardNo, phone, tenant })
          .then((res) => {
            // 2. 根据接口返回的错误信息,修改相应报错信息
            if (res.code) {
              // 3.证件号,手机号匹配，发送验证码
              this.phoneCheckCode('phone');
            } else {
              // 4.不匹配,返回错误
              this.phoneError = res.error.msg;
            }
          });
      } else {
        console.log("error submit!!");
        return false;
      }
    },
    /* ***** 验证码按钮能否发送短信,失败验证返回错误 ***** */
    getVerCode4Email(state) {
      // 1.判断验证码功能是否开启，调用接口
      if (state) {
        let { cardNo, email, tenant } = this.resetPass;
        this.$api.login
          .checkUserCardPhone({ cardNo, email, tenant })
          .then((res) => {
            // 2. 根据接口返回的错误信息,修改相应报错信息
            if (res.code) {
              // 3.证件号,手机号匹配，发送验证码
              this.phoneCheckCode('email');
            } else {
              // 4.不匹配,返回错误
              this.emailError = res.error.msg;
            }
          });
      } else {
        console.log("error submit!!");
        return false;
      }
    },
    /* ***** 发送验证码后，倒计时两分钟( 设置浏览器缓存,防止刷新页面可以重新获取验证码 ) ***** */
    // countDown() {
    //   if (this.count == 0) {
    //     // true : 可以重新获取验证码
    //     this.isgetCode = true;
    //     this.countDownText = "获取验证码";
    //     this.count = 120;
    //     clearTimeout(this.timer);
    //     this.timer = null;
    //   } else {
    //     // false : 无法再次获取验证码
    //     this.isgetCode = false;
    //     this.countDownText = this.count + "秒后获取";
    //     this.count--;
    //     this.timer = setTimeout(() => {
    //       this.countDown();
    //     }, 1000);
    //   }
    // },
    /* ***** 页面刷新不重置的定时器 ( localStorage ) ***** */
    GetCode() {
      let endMsRes = new Date().getTime() + 120000;
      localStorage.setItem("resetPassword_myEndTime", JSON.stringify(endMsRes));
      this.codeCountDown(endMsRes);
    },
    GetCode4Email() {
      let endMsRes = new Date().getTime() + 120000;
      localStorage.setItem("resetPassword_myEndTime4Email", JSON.stringify(endMsRes));
      this.codeCountDown4Email(endMsRes);
    },
    codeCountDown(endMsRes) {
      this.isgetCode = false;
      this.countDownText = this.count + "秒后获取";
      this.count = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.count--;
        if (this.count < 1) {
          this.isgetCode = true;
          this.countDownText = "获取验证码";
          this.count = 120;
          localStorage.removeItem("resetPassword_myEndTime");
          clearTimeout(time);
        } else {
          this.codeCountDown(endMsRes);
        }
      }, 1000);
    },
    codeCountDown4Email(endMsRes) {
      this.isgetCode4Email = false;
      this.countDownText4Email = this.count4Email + "秒后获取";
      this.count4Email = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.count4Email--;
        if (this.count4Email < 1) {
          this.isgetCode4Email = true;
          this.countDownText4Email = "获取验证码";
          this.count4Email = 120;
          localStorage.removeItem("resetPassword_myEndTime4Email");
          clearTimeout(time);
        } else {
          this.codeCountDown4Email(endMsRes);
        }
      }, 1000);
    },
    /* ***** 获取验证码接口 ***** */
    phoneCheckCode(inputName) {
      let type = 2;
      let { tenant,phone,email } = this.resetPass;
      let params = {};
      if(inputName == 'phone'){
        params = { phone, type, tenant, email:'' };
      }else{
        params = { phone:'', type, tenant, email };
      }
      this.$api.login.phoneCheckCode(params).then((res) => {
        // 成功发送验证码后,设置获取验证码倒计时
        if (res.code == 1) {
          if(inputName == 'phone'){
            this.GetCode();
          }else{
            this.GetCode4Email();
          }
        }
      });
    },

    /* ***** 判断用户两次输入密码是否相同 ***** */
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPass.password !== this.resetPass.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    /* ***** 聚焦清除重置验证码错误信息 ***** */
    clearError() {
      this.vCodeError = "";
    },

    /* ***** 下一步操作(全部表单验证) ***** */
    next(formName) {
      // 1. 判断表单是否全部通过验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { tenant, cardNo, phone, vCode, email, eCode } = this.resetPass;
          let params = {};
          if(this.activeName == 'phone'){
            params = { tenant, cardNo, phone , email:'', checkCode:vCode };
          }else{
            params = { tenant, cardNo, phone:'' , email, checkCode:eCode };
          }
          // 2. 手机号,证件号查询信息接口
          this.$api.login.queryInfo(params).then((res) => {
              if (res.code) {
                this.resetPass.userId = res.data;
                // 输入的验证码正确,可以进入下一步
                this.step = 2;
              } else {
                // 验证码错误,给予相应提示信息
                if(this.activeName == 'phone'){
                  this.vCodeError = res.error.msg;
                }else{
                  this.eCodeError = res.error.msg;
                }
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    rightEditPsd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { userId, password, confirmPassword, tenant } = this.resetPass;
          this.$api.login
            .editPsd({ userId, password, confirmPassword, tenant })
            .then((res) => {
              if (res.code) {
                this.step = 3;
                this.pushTime = 5;
                this.timer = setInterval(() => {
                  if (this.pushTime === 0) {
                    clearInterval(this.timer);
                    this.$router.push({
                      name: "Login",
                      query: { tenant: this.resetPass.tenant },
                    });
                  }
                  this.pushTime--;
                }, 1000);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleLogin() {
      this.$router.push({
        name: "Login",
        query: { tenant: this.resetPass.tenant },
      });
    },
  },
};
</script>


<style lang="less" scoped>
.elTabsCss{
  width:360px; 
  margin:0 auto; 
  margin-top: 20px;
}
/* ***** 去掉 "*" 号 ***** */
/deep/ .el-form-item__label::before {
  display: none;
}
/deep/ .el-form-item:last-child {
  margin-bottom: 0;
}
/* ***** 12/01 已有账号样式 ***** */
.login-box {
  .back-login {
    font-size: 14px;
    height: 20px;
    text-align: center;
    margin-top: 16px;
    span {
      color: #9299a6;
    }
    a {
      color: #006aff;
      text-decoration: none;
    }
  }
}

.resetPassword {
  background: rgba(255, 255, 255, 0.95);
  width: 100%;
  /* ***** 修改大盒子高度 ***** */
  height: auto;
  padding: 32px 48px 40px 48px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  /* IE 兼容 */
  height: auto\0;
  padding-bottom: 60px\0;
  .reset-pass-header {
    color: #333;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 16px;
    border-bottom: 1px solid #eeeeee;
  }
  .reset-pass-step-box {
    margin-top: 20px;
    height: 46px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    .step-item.active {
      .step-item-num {
        background-color: #006aff;
        color: #fff;
      }
      .step-item-name {
        color: #006aff;
      }
    }
    .step-item {
      display: flex;
      align-items: center;
      .step-item-num {
        width: 28px;
        height: 28px;
        background-color: #d8d8d8;
        color: #fff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
      }
      .step-item-name {
        margin-left: 14px;
        color: #666666;
        font-size: 13px;
        font-weight: bold;
      }
    }
    .step-division.active {
      .step-division__ {
        background-color: #006aff;
      }
    }
    .step-division {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      .step-division__ {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #d5d5d5;
      }
      .step-division__:nth-child(2) {
        margin: 0 8px;
      }
    }
  }
  .reset-pass-form {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    /* ***** 获取验证码样式 ***** */
    .getCode {
      text-align: right;
      font-size: 14px;
      line-height: 20px;
      width: 84px;
      height: 20px;
      position: absolute;
      right: 12px;
      top: calc(50% + 1px);
      color: #9299a6;
      cursor: not-allowed;
    }
    /* ***** 允许点击时获取验证码样式 ***** */
    .isgetCode {
      text-align: right;
      font-size: 14px;
      line-height: 20px;
      width: 84px;
      height: 20px;
      position: absolute;
      right: 12px;
      top: calc(50% + 1px);
      color: #006aff;
      cursor: pointer;
    }
    .next.active {
      background: #006aff;
    }
    .next {
      width: 360px;
      height: 40px;
      background: #d5d5d5;
      border-radius: 100px;
      color: #fff;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
    }
    .code-form {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code-time {
        width: 100px;
        height: 38px;
        background: #fff;
        color: #006aff;
        border: 1px solid #006aff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .get-code-btn {
        cursor: pointer;
        width: 102px;
        height: 38px;
        border: 1px solid #d5d5d5;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin-top: 2px;
      }
      .get-code-btn.active {
        border: 1px solid #006aff;
        color: #006aff;
      }
    }
    .el-form-item {
      // margin-bottom: 24px !important;
      /deep/ .el-form-item__label {
        line-height: 1;
        margin-bottom: 8px;
      }
      /deep/ .el-input {
        width: 100%;
      }
      /deep/ .el-input__inner {
        width: 360px;
        height: 40px;
      }
    }
  }
  .reset-finsh {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .reset-success-icon {
      margin-bottom: 14px;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .reset-success-text {
      color: #08bd6b;
      font-size: 24px;
      font-weight: bold;
    }
    .auto-go-login {
      margin-top: 12px;
      color: #9299a6;
      font-size: 16px;
      span {
        color: #006aff;
        cursor: pointer;
      }
    }
  }
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
/deep/ .el-form {
  width: 360px\0;
}
</style>